<template>
  <v-img :src="backgroundImg" class="page-vimg with-header">
    <v-container fill-height pa-0>
      <v-layout align-center>
        <v-flex xs12>
          <v-card class="text-xs-center margin-auto border-radius6 box-white-500-glow elevation-10 ">
            <v-layout align-center justify-center row fill-height wrap>
              <v-flex xs12 class="text-xs-center mt-0">
                <img src="/static/vuse-circle-white.svg" alt="Vuse" class="text-xs-center" height="100" >
                <div class="headline">Crear Cuenta</div>
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                  <v-layout wrap row pa-4>
                    <v-flex xs12 pa-0>
                      <v-text-field
                        color="purple darken-2"
                        label="Nombre"
                        v-model="name"
                        :rules="nameRules"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="email"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="password"
                        :rules="passwordRules"
                        label="Contraseña"
                        type="password"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="passwordRepeated"
                        :rules="passwordRepeatedRules"
                        label="Repite Contraseña"
                        type="password"
                        required
                      ></v-text-field>
                      <v-checkbox color="primary" v-model="agreeToPolicy" 
                      :rules="agreeToPolicyRules" required>
                        <div slot="label">
                          <span class="grey--text">Aprueba la  </span><span class="transparent blue--text" @click.stop="dialog = !dialog"> Política dee Privacidad</span>
                        </div>
                      </v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout row wrap text-xs-center>
                        <!-- Login form submit -->
                        <v-flex xs12 class="no-mrpd">
                          <v-btn color="act" type="submit" :disabled="!valid" block @click.prevent="doRegister">Registrar Cuenta</v-btn>
                        </v-flex>
                        <v-flex xs12 style="margin-top: 15px;">
                          <p><strong>¿Ya tienes una cuenta?</strong></p>
                          <v-btn :to="{ name: 'LoginPage' }" flat round color="orange darken-4" dark bold outline >Accede a tu cuenta</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Terms & privacy policy
        </v-card-title>

        <v-card-text>
          {{ this.policyText }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat round color="orange darken-4" dark bold outline  @click="dialog = false">
            Back
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :color="snackbarColor" absolute top right>
      <span>{{ snackbarText }}</span>
      <!-- <v-icon dark>check_circle</v-icon> -->
    </v-snackbar>
  </v-img>
</template>

<script>
import firebase from "firebase";
export default {
  beforeCreate() {
    window.scrollTo(0, 0);
  },
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  data() {
    return {
      valid: true,
      lazy: false,
      name: "",
      nameRules: [
        v => !!v || "El nombre es obligatorio",
        v => (v && v.length <= 50) || "Name must be less than 50 characters"
      ],
      email: "",
      emailRules: [
        v => !!v || "E-mail es obligatorio",
        v =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v) || "E-mail debe ser válido"
      ],
      password: "",
      passwordRules: [
        v => !!v || "Debes dar una contraseña",
        v => (v && v.length > 5) || "La contraseña deebe tener 6 caracteres como mínimo"
      ],
      passwordRepeated: "",
      passwordRepeatedRules: [
        v => !!v || "Debes dar una contraseña ",
        v => (v && v.length > 5) || "La contraseña deebe tener 6 caracteres como mínimo",
        v => (v && this.password === this.passwordRepeated) || "Las contraseñas no coinciden "
      ],
      agreeToPolicy: false,
      agreeToPolicyRules: [
        v => !!v || 'Debes aceptar para continuar!'
      ],
      dialog: false,
      snackbar: false,
      snackBarText: '',
      snackBarColor: '',
      policyText: `
        <h5>What is privacy?</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        <h5>Terms</h5>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborumLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
        `,
      backgroundImg: "/static/doc-images/HexesisMaterial04.png"
    };
  },
  methods: {
    doRegister() {
      const self = this;
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.email, this.password)
        .then(
          function(res) {
            self.snackbarColor = 'success';
            self.snackbarText = 'Registro completado. Por favor verifica tu dirección de correo haciendo click en el enlace enviado por correo. ';
            self.snackbar = true;
            self.$refs.form.reset()
            res.user.sendEmailVerification();
            self.$router.push({ name: "LoginPage" });
          },
          function(error) {
            self.snackbarColor = 'error';
            self.snackbarText = error.message;
            self.snackbar = true;
            // alert("Error");
          }
        );
    },
    submit2() {
      this.snackbar = true;
      setTimeout(() => {
        this.$router.push({
          name: "HelloWorld"
        });
      }, 2000);
    },
  },
  beforeDestroy() {
    this.$refs.form.reset();
  }
};
</script>
